export var palette = {
    background: { homePage: '#f5f7f9', homePageDark: '#242424' },
};
